export const roundNumber = (num: number) => Number(num.toFixed(2))
